export interface CompanionOption {
  id: number;
  bundleTitle: string;
  type: string;
  iconUrl: string;
  tabIndex: number;
}

export enum CompanionType {
  SCAN,
  MANUAL_ENTRY,
}
